export const DOWNLOAD_DB_NAME = "streamline-download-transfer";

export const DOWNLOAD_DB_VERSION = 1;

export const DOWNLOAD_STORES = {
  jobs: "downloadJobs",
  files: "downloadFiles",
  chunks: "downloadChunks",
  events: "downloadEvents",
  schemaMeta: "schemaMeta",
};

export const DOWNLOAD_INDEXES = {
  [DOWNLOAD_STORES.jobs]: [
    { name: "status", keyPath: "status" },
    { name: "sourceType", keyPath: "sourceType" },
    { name: "componentId", keyPath: "componentId" },
    { name: "updatedAt", keyPath: "updatedAt" },
    { name: "createdAt", keyPath: "createdAt" },
  ],
  [DOWNLOAD_STORES.files]: [
    { name: "jobId", keyPath: "jobId" },
    { name: "status", keyPath: "status" },
    { name: "uri", keyPath: "uri" },
    { name: "jobId_status", keyPath: ["jobId", "status"] },
    { name: "jobId_safeRelativePath", keyPath: ["jobId", "safeRelativePath"] },
  ],
  [DOWNLOAD_STORES.chunks]: [
    { name: "jobId", keyPath: "jobId" },
    { name: "fileRecordId", keyPath: "fileRecordId" },
    { name: "status", keyPath: "status" },
    { name: "jobId_status", keyPath: ["jobId", "status"] },
    { name: "fileRecordId_status", keyPath: ["fileRecordId", "status"] },
    { name: "fileRecordId_start", keyPath: ["fileRecordId", "start"] },
  ],
  [DOWNLOAD_STORES.events]: [
    { name: "jobId", keyPath: "jobId" },
    { name: "fileRecordId", keyPath: "fileRecordId" },
    { name: "createdAt", keyPath: "createdAt" },
    { name: "level", keyPath: "level" },
  ],
  [DOWNLOAD_STORES.schemaMeta]: [],
};
